export default __webpack_public_path__ + "static/media/scale.ac954a9b.svg";